import { useLocation } from 'react-router-dom';

const ROUTE_MAP: Record<string, string> = {
  '': 'network',
  'subnetwork': 'subnetwork',
  'list': 'list',
  'overlay': 'overlay',
};

/**
 * Returns the appropriate help section based on the current route.
 * Maps page routes to their corresponding help documentation sections.
 *
 * @returns The help section identifier ('network' | 'subnetwork' | 'list' | 'overlay')
 */
export const useHelpSection = (): string => {
  const location = useLocation();

  const path = location.pathname.replace(/^\//, ''); // Remove leading slash
  return ROUTE_MAP[path] || 'network';
};